import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
	BannerContainerStyled,
	BannerHeaderStyled,
	BannerImgMStyled,
	BannerImgStyled,
	BannerImgTStyled,
	BannerTextStyled,
	ButtonStyled,
} from './IdeasBanner.styles';

export const IdeasBanner: FC = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { t } = useTranslation();

	return (
		<BannerContainerStyled>
			<BannerHeaderStyled>{t(`Marketplace_Ideas_Heading`)}</BannerHeaderStyled>
			<BannerTextStyled>{t(`Marketplace_Ideas_Text`)}.</BannerTextStyled>
			<a href='mailto:support@dodopizza.com'>
				<ButtonStyled>{t(`Marketplace_Ideas_Button`)}</ButtonStyled>
			</a>
			<BannerImgStyled src='https://cdn.dodostatic.net/static/marketplace/ideas/desktop' />
			<BannerImgTStyled src='https://cdn.dodostatic.net/static/marketplace/ideas/tablet' />
			<BannerImgMStyled src='https://cdn.dodostatic.net/static/marketplace/ideas/mobile' />
		</BannerContainerStyled>
	);
};
